//import Grid from '@mui/material/Grid';
import RecordsText from './RecordsText';
import SectionRecordCard from './SectionRecordCard';
import SectionStructure from '../../components/Section/SectionStructure';


export default function SectionRecords() {

    
 return (

        <SectionStructure
    
            sectiontext=    { <RecordsText /> }
            sectioncards=  {<SectionRecordCard /> }

            />

    )
}